import TabHeader from '@/components/business/games/tab-header';
import globalStore from '@/services/global.state';
import theme from '@/style';
import {goTo} from '@/utils';
import React from 'react';

const LotteryTab = ({
  index,
  setIndex,
  orderNum,
}: {
  index?: number;
  setIndex?: (v: number) => void;
  configId?: number;
  refreshCode?: number;
  orderNum?: number;
}) => {
  const [tablist] = React.useState([
    {
      title: 'result',
      key: 'result',
    },
    {
      title: 'analyze',
      key: 'analyze',
    },
    {
      title: 'order',
      key: 'order',
    },
  ]);

  const handleTabChange = React.useCallback(
    (key: string) => {
      if (key === 'order' && !globalStore.token) {
        goTo('Login');
        return;
      }
      setIndex?.(tablist.findIndex(v => v.key === key));
    },
    [setIndex, tablist],
  );

  if (typeof document !== 'undefined') {
    return (
      <div style={stylesWeb.wrap}>
        {tablist.map(item => {
          const isActive = item.key === tablist[index || 0]?.key;
          const showOrderNum = item.key === 'order' && !!orderNum;
          return (
            <button
              key={item.key}
              onClick={() => handleTabChange(item.key)}
              style={stylesWeb.tabBtn}
              type="button">
              <span
                style={{
                  ...stylesWeb.tabText,
                  ...(isActive
                    ? stylesWeb.tabTextActive
                    : stylesWeb.tabTextInactive),
                }}>
                {item.title === 'result'
                  ? 'Result History'
                  : item.title === 'order'
                  ? 'My order'
                  : 'Analyze'}
              </span>
              {showOrderNum ? (
                <span style={stylesWeb.badge}>{orderNum}</span>
              ) : null}
              {isActive ? <div style={stylesWeb.cursor} /> : null}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <TabHeader
      routes={tablist}
      onTabPress={i => handleTabChange(tablist[i]?.key)}
      index={index || 0}
      orderNum={orderNum}
      orderKey="order"
    />
  );
};

export default LotteryTab;

const stylesWeb: Record<string, React.CSSProperties> = {
  wrap: {
    display: 'flex',
    backgroundColor: '#fff',
    borderBottom: '1px solid #D8E0EA',
    padding: '0 0.75rem',
  },
  tabBtn: {
    position: 'relative',
    flex: 1,
    minHeight: '3rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.25rem',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
  },
  tabText: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  },
  tabTextActive: {
    color: theme.basicColor.dark,
    fontWeight: 700,
  },
  tabTextInactive: {
    color: theme.fontColor.second,
    fontWeight: 500,
  },
  badge: {
    minWidth: '1rem',
    height: '1rem',
    padding: '0 0.25rem',
    borderRadius: '9999px',
    backgroundColor: theme.basicColor.primary,
    color: '#fff',
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: 700,
    textAlign: 'center',
  },
  cursor: {
    position: 'absolute',
    left: '50%',
    bottom: 0,
    width: '1.25rem',
    height: '0.25rem',
    transform: 'translateX(-50%)',
    backgroundColor: theme.basicColor.primary,
  },
};
